<script lang="ts" setup>
import { computed, nextTick, useTemplateRef } from 'vue';
import AssistantMessageBubble from './AssistantMessageBubble.vue';
import type { AssistantMessage } from './types';

const props = defineProps<{
  loading: boolean;
  messages: AssistantMessage[];
}>();

const messageListRef = useTemplateRef('messageList');

const visibleMessages = computed(() => props.messages.slice(-16));

const scrollToBottom = async () => {
  await nextTick();

  if (!messageListRef.value) {
    return;
  }

  messageListRef.value.scrollTop = messageListRef.value.scrollHeight;
};

defineExpose({
  scrollToBottom,
});
</script>

<template>
  <div
    ref="messageList"
    class="min-h-0 flex flex-1 flex-col gap-12 overflow-y-auto p-18"
  >
    <div
      v-if="props.loading"
      class="self-start rounded-15 rounded-bl-5 bg-#EEF6FF px-14 py-11 text-14 text-#25324B leading-23"
    >
      正在加载历史消息...
    </div>

    <AssistantMessageBubble
      v-for="message in visibleMessages"
      :key="message.id"
      :message="message"
    />
  </div>
</template>
